<i18n>
{
  "en": {
    "permissionCardMessage": "Login and grant permission",
    "requirePermissionTitle": "To continue, Livepaow need to grant these permission.",
    "requireEmailTitle": "Email",
    "requireEmailDetail": "We need your email to verify your account.",
    "requireEmailPrivacy": "We are committed to protecting your privacy ",
    "requireUserFriendsTittle": "Friend list",
    "requireUserFriendsDetail": "We use your friend list for share the same experience or benefit within Livepaow between you and your friends",
    "requireUserFriendsPrivacy": "Only friends who use Livepaow and shareAlike | Your friend only see what your permit"
  },
  "th": {
    "permissionCardMessage": "เข้าสู่ระบบและให้สิทธิ์อีกครั้ง",
    "requirePermissionTitle": "Livepaow จำเป็นต้องได้รับสิทธิดังต่อไปนี้ เพื่อดำเนินการต่อ",
    "requireEmailTitle": "Email ของคุณ",
    "requireEmailDetail": "เราจำเป็นต้องใช้ Email ของคุณเพื่อยืนยันตัวตนของคุณ เพื่อไม่ให้เกิดความสับสนกับผู้ใช้อื่น",
    "requireEmailPrivacy": "เราจะไม่เปิดเผยข้อมูลของคุณ โดยไม่ได้รับอนุญาต",
    "requireUserFriendsTittle": "รายชื่อเพื่อนของคุณ",
    "requireUserFriendsDetail": "เราใช้รายชื่อเพื่อนของคุณ เพื่อเพิ่มประสบการณ์ในสิ่งที่น่าสนใจ สิทธิ์ประโยชน์ต่างๆที่คุณมีร่วมกันภายใน Livepaow ระหว่างคุณและเพื่อนๆ",
    "requireUserFriendsPrivacy": "เราเข้าถึงเฉพาะเพื่อนที่ใช้ Livepaow เท่านั้น | เพื่อนจะเข้าถึงเฉพาะข้อมูลที่คุณอนุญาตเเท่านั้น"
  }
}
</i18n>
<template>
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md6
        lg4
        class="mt-sm-12"
      >
        <v-alert
          dense
          type="info"
        >
          {{ $t('requirePermissionTitle') }}
        </v-alert>
        <div v-for="alert in errorToAlert" :key="alert.id">
          <v-alert
            :icon="alert.icon"
            prominent
            text
            type="info"
          >
            <div class="title font-italic font-weight-medium">
              {{ $t(alert.title) }}
            </div>
            <div>{{ $t(alert.detail) }}</div>
            <v-divider
              class="info my-2"
              style="opacity: 0.22"
            ></v-divider>
            <div>
              <div>
                {{ $t(alert.privacy) }}
              </div>
            </div>
          </v-alert>

        </div>

        <v-card class="elevation-12 pb-5 mb-12">
          <v-toolbar
            color="blue"
            dark
            flat
          >
            <v-toolbar-title>{{ $t('permissionCardMessage') }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <paow-facebook-login-button
              class="mt-5"
              :x-large-button="true"
              :large-icon="true"
              :re-request="errors.permission"
            />
          </v-card-text>
        </v-card>

      </v-flex>
    </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import helpers from '../mixins/helpers'
import PaowFacebookLoginButton from '../components/PaowFacebookLoginButton'

export default {
  name: 'Home',
  mixins: [helpers],
  components: { PaowFacebookLoginButton },
  data () {
    return {
      errorToAlert: []
    }
  },
  computed: {
    ...mapState(['errors']),
    noErrors () {
      return this.errors.permission === null
    }
  },
  created () {
    if (this.noErrors) {
      this.navigateTo('login')
    }
    this.errors.permission.forEach(permission => {
      switch (permission) {
        case 'email':
          this.errorToAlert.push({
            id: 'email',
            title: 'requireEmailTitle',
            detail: 'requireEmailDetail',
            privacy: 'requireEmailPrivacy',
            icon: 'fas fa-envelope'
          })
          break
        case 'user_friends' :
          this.errorToAlert.push({
            id: 'user_friends',
            title: 'requireUserFriendsTittle',
            detail: 'requireUserFriendsDetail',
            privacy: 'requireUserFriendsPrivacy',
            icon: 'fas fa-user-friends'
          })
      }
    })
  }
}
</script>

<style>

</style>
